import { TimeDimensionGranularity } from '@cubejs-client/core';
import moment from 'moment';

export function granularityDateFormater(date: Date, granularity: TimeDimensionGranularity | undefined, languageCode: string): string {
	const m = moment(date).locale(languageCode);
	switch (granularity) {
		case 'second':
			return m.format('D MMM YYYY HH:mm:ss');
		case 'minute':
			return m.format('D MMM YYYY HH:mm');
		case 'hour':
			return m.format('D MMM YYYY HH');
		case 'day':
			return m.format('D MMM YYYY');
		case 'week':
			return m.format('Wo MMM YY');
		case 'month':
			return m.format('MMM YYYY');
		case 'quarter':
			return m.format('Qo YYYY');
		case 'year':
			return m.format('YYYY');
		default:
			return m.format('D MMM YYYY HH:mm:ss');
	}
}
